var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "4 4 22 22",
    enableBackground: "new 4 4 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4H6C4.9,4,4,4.9,4,6v18c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V6C26,4.9,25.1,4,24,4z M22.1,13.7c-0.1,0-0.3,0-0.4,0 c-1.5,0-2.8-0.8-3.6-1.9c0,3,0,6.5,0,6.6c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9c0.1,0,0.2,0,0.3,0 v2.4c-0.1,0-0.2,0-0.3,0c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.6-1.1,2.6-2.5c0-0.1,0-11.2,0-11.2h2.3c0.2,2,1.9,3.7,3.9,3.8 V13.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok);
export default __webpack_public_path__ + "static/media/social-tiktok.ef1b54f16aff2c2132593b28032c73c4.svg";
export { ForwardRef as ReactComponent };